var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.922px",
    height: "16.043px",
    viewBox: "78.1 152.273 16.922 16.043",
    enableBackground: "new 78.1 152.273 16.922 16.043",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009044",
    d: "M91.099,156.703l3.923-3.738l-0.727-0.691l-4.118,3.924c-1.084-0.532-2.32-0.904-3.682-0.904 c-5.364,0.125-8.208,4.707-8.326,4.902c-0.094,0.153-0.093,0.344,0.004,0.496c0.081,0.128,1.362,2.113,3.597,3.517l-3.584,3.416 l0.727,0.692l3.777-3.599c1.053,0.514,2.268,0.87,3.638,0.87l0.129-0.005c0.239,0.023,0.476,0.034,0.706,0.034 c4.859,0,7.578-4.744,7.691-4.947c0.091-0.158,0.081-0.352-0.024-0.502C94.74,160.041,93.352,158.097,91.099,156.703z  M79.226,160.437c0.653-0.92,3.191-4.07,7.281-4.166c1.046,0,2.02,0.265,2.9,0.659l-0.929,0.886 c-0.557-0.382-1.235-0.612-1.972-0.612c-1.872,0-3.396,1.452-3.396,3.235c0,0.702,0.242,1.348,0.642,1.879l-1.234,1.176 C80.801,162.466,79.643,161.013,79.226,160.437z M88.876,160.439c0,1.244-1.063,2.257-2.369,2.257c-0.481,0-0.929-0.14-1.303-0.376 l3.278-3.123C88.729,159.553,88.876,159.98,88.876,160.439z M84.139,160.439c0-1.244,1.063-2.257,2.368-2.257 c0.453,0,0.872,0.128,1.231,0.339l-3.245,3.092C84.273,161.269,84.139,160.87,84.139,160.439z M87.162,164.638 c-0.197,0-0.398-0.01-0.668-0.031l-0.167,0.002c-1.052,0-2.009-0.252-2.864-0.63l1.012-0.964c0.568,0.408,1.267,0.659,2.032,0.659 c1.873,0,3.396-1.451,3.396-3.235c0-0.729-0.264-1.395-0.692-1.937l1.14-1.086c1.746,1.035,2.989,2.479,3.439,3.05 C93.17,161.414,90.798,164.638,87.162,164.638z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed01);
export default __webpack_public_path__ + "static/media/eye_closed-01.1de76e242984023c2b353bf538ac8052.svg";
export { ForwardRef as ReactComponent };